// Maria Gautam, site behaviour. Ported from site-v4/shared.js.
// The nav, footer, email band and sticky mobile CTA are Liquid now (header and
// footer section groups); this file only wires their behaviour.

// Email band: remembered per device, as in site-v4. The head script in
// layout/theme.liquid reads the same key before first paint.
var SIGNUP_KEY = 'mg-signup-done';
function hasSubscribed() { try { return localStorage.getItem(SIGNUP_KEY) === '1'; } catch (e) { return false; } }
function markSubscribed() { try { localStorage.setItem(SIGNUP_KEY, '1'); } catch (e) {} }

// Shopify contact and customer forms. The form posts in the background and
// onSuccess glides to the thank-you view. Shopify's spam check (hCaptcha, on by
// default in Online Store > Preferences) catches the submit first, fetches a
// token and submits again; the background post waits for that token. If
// Shopify can't confirm the post (a challenge, an error, no connection), the
// form posts normally instead: the page reloads showing the thank-you view,
// or Shopify's own challenge page if it wants one.
function captchaToken(form) {
  var t = form.querySelector('[name="h-captcha-response"], [name="g-recaptcha-response"]');
  return t ? t.value : '';
}
function captchaActive() { return !!(window.Shopify && window.Shopify.captcha); }

function postShopifyForm(form, flag) {
  if (!window.fetch || !window.FormData) return Promise.resolve(false);
  form.classList.add('is-posting');
  return fetch(form.getAttribute('action') || window.location.pathname, {
    method: 'POST',
    body: new FormData(form),
    credentials: 'same-origin',
    headers: { 'Accept': 'text/html' }
  }).then(function (res) {
    form.classList.remove('is-posting');
    return !!(res.ok && res.url && res.url.indexOf(flag + '=true') > -1);
  }).catch(function () {
    form.classList.remove('is-posting');
    return false;
  });
}

// Hand the form back to the browser and Shopify's spam check for a normal post.
// The used token goes, so Shopify fetches a fresh one.
function postNormally(form) {
  form.dataset.native = '1';
  form.classList.remove('is-posting');
  var t = form.querySelector('[name="h-captcha-response"], [name="g-recaptcha-response"]');
  if (t) t.remove();
  if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
}

// validate(form) returns false to stop; onSuccess runs after a confirmed background post
function wireShopifyForm(form, flag, validate, onSuccess) {
  if (!form || form.dataset.shopifyWired) return;
  form.dataset.shopifyWired = '1';
  var waiting = null;
  form.addEventListener('submit', function (e) {
    if (form.dataset.native) return;
    e.preventDefault();
    if (form.classList.contains('is-posting')) return;
    if (validate && validate(form) === false) return;
    if (captchaActive() && !captchaToken(form)) {
      // Shopify is fetching a token and will submit again; if it never does, post normally
      clearTimeout(waiting);
      waiting = setTimeout(function () { postNormally(form); }, 12000);
      return;
    }
    clearTimeout(waiting);
    postShopifyForm(form, flag).then(function (ok) {
      if (!ok) { postNormally(form); return; }
      onSuccess();
    });
  });
}

function wireSignup() {
  document.querySelectorAll('.signup-form').forEach(function (form) {
    wireShopifyForm(form, 'customer_posted', function () {
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value || email.value.indexOf('@') < 0) { email && email.focus(); return false; }
    }, function () {
      markSubscribed();
      glide(form.closest('.signup-band') || form, function () {
        form.querySelector('.signup-row').hidden = true;
        form.querySelector('.signup-label').hidden = true;
        form.querySelector('.signup-done').hidden = false;
      });
    });
  });
}

// --- One motion for anything that changes height. glide() measures the box,
// applies the change, then eases from the old height to the new one on the
// --glide curve (styles.css) and lets go. glideTo() is the lower-level form
// for cases that must keep content visible while shrinking (accordions).
function glideTo(el, from, to, after) {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || Math.abs(to - from) < 1) { el.style.height = ''; if (after) after(); return; }
  var finished = false;
  var done = function (e) {
    if (e && (e.target !== el || e.propertyName !== 'height')) return;
    if (finished) return;
    finished = true;
    el.removeEventListener('transitionend', done);
    el.classList.remove('is-gliding');
    el.style.height = '';
    if (after) after();
  };
  el.style.height = from + 'px';
  el.classList.add('is-gliding');
  void el.offsetHeight;
  el.style.height = to + 'px';
  el.addEventListener('transitionend', done);
  setTimeout(function () { done(); }, 600);
}
function glide(el, change, after) {
  if (!el) { if (change) change(); if (after) after(); return; }
  var from = el.getBoundingClientRect().height;
  if (change) change();
  el.style.height = '';
  var to = el.getBoundingClientRect().height;
  glideTo(el, from, to, after);
}

function wireMenuToggle() {
  const btn = document.querySelector('.nav-menu-btn');
  const panel = document.getElementById('menu');
  const closeBtn = document.querySelector('.nav-close');
  const header = document.querySelector('header.site-nav');
  if (!btn || !panel || btn.dataset.wired) return;
  btn.dataset.wired = '1';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Animate over the measured content height, capped so the drawer never
  // outgrows the screen; it scrolls inside once settled
  function targetHeight() { return Math.min(panel.scrollHeight, Math.round(window.innerHeight * 0.8)); }
  function open() {
    panel.classList.add('open');
    if (header) header.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.remove('is-settled');
    if (reduce) { panel.style.height = targetHeight() + 'px'; panel.classList.add('is-settled'); return; }
    panel.style.height = '0px';
    void panel.offsetHeight;
    panel.style.height = targetHeight() + 'px';
  }
  function close() {
    panel.classList.remove('open');
    panel.classList.remove('is-settled');
    if (header) header.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    if (reduce) { panel.style.height = '0px'; return; }
    panel.style.height = panel.getBoundingClientRect().height + 'px';
    void panel.offsetHeight;
    panel.style.height = '0px';
  }
  panel.addEventListener('transitionend', function (e) {
    if (e.propertyName !== 'height' || !panel.classList.contains('open')) return;
    panel.classList.add('is-settled');
  });
  window.addEventListener('resize', function () {
    if (panel.classList.contains('open')) panel.style.height = targetHeight() + 'px';
  });
  function toggle() {
    if (panel.classList.contains('open')) close(); else open();
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    toggle();
  });
  if (closeBtn) closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('open')) close();
  });
  // Close on any click outside the panel or the toggle button
  document.addEventListener('click', function (e) {
    if (!panel.classList.contains('open')) return;
    if (panel.contains(e.target) || btn.contains(e.target)) return;
    close();
  });
  // Close after clicking any menu link so the panel doesn't obscure the destination
  panel.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
}

// Smooth in-page scrolling with ease-in-out. Overrides the browser's default
// smooth easing, which cannot be tuned from CSS.
// Moves off immediately, decelerates into place. An ease-in-out crawls for the
// first third then lurches, which reads badly over long distances.
function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}

function easedScrollTo(target) {
  var max = document.documentElement.scrollHeight - window.innerHeight;
  var end = Math.max(0, Math.min(target, max));
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, end);
    return;
  }
  var start = window.pageYOffset;
  var delta = end - start;
  if (Math.abs(delta) < 1) return;

  // Longer jumps get a little more time, but never a crawl.
  var duration = Math.min(700, Math.max(350, Math.abs(delta) * 0.5));
  var t0 = null;

  function step(now) {
    if (t0 === null) t0 = now;
    var p = Math.min((now - t0) / duration, 1);
    window.scrollTo(0, start + delta * easeOutCubic(p));
    if (p < 1) window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);
}

function navHeight() {
  var nav = document.querySelector('header.site-nav');
  return nav ? nav.getBoundingClientRect().height : 0;
}

function wireSmoothScroll() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.dataset.smoothScroll) return;
  document.documentElement.dataset.smoothScroll = '1';

  function scrollToY(target) { easedScrollTo(target); }

  function offsetFor(el) {
    var navH = navHeight();
    var style = window.getComputedStyle(el);
    var margin = parseFloat(style.scrollMarginTop) || 0;
    return el.getBoundingClientRect().top + window.pageYOffset - Math.max(navH, margin);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var el = document.getElementById(href.slice(1));
    if (!el) return;
    e.preventDefault();
    scrollToY(offsetFor(el));
    if (history.pushState) history.pushState(null, '', href);
  });
}

// Homepage only: the nav wordmark fades in with scroll position, reaching full
// strength once the hero wordmark has cleared the top of the window. The hero
// wordmark sits on the photo or under it (.hero-lockup marks whichever holds it).
function wireWordmarkFade() {
  var mark = document.querySelector('.nav-wordmark[data-fade]');
  if (!mark || mark.dataset.wired) return;
  mark.dataset.wired = '1';
  var nav = document.querySelector('header.site-nav');
  if (!document.querySelector('.hero-lockup')) { mark.style.opacity = 1; return; }

  var ticking = false;

  function update() {
    ticking = false;
    var hero = document.querySelector('.hero-lockup');  // looked up each time: the theme editor replaces it
    if (!hero) return;
    var navH = nav ? nav.getBoundingClientRect().height : 0;
    var y = window.pageYOffset;
    var heroBottom = hero.getBoundingClientRect().bottom + y;
    var end = heroBottom - navH;          // hero fully behind the nav
    var start = Math.max(0, end - 220);   // fade over the last stretch
    var p = end <= start ? 1 : (y - start) / (end - start);
    p = Math.max(0, Math.min(1, p));
    mark.style.opacity = p;
    mark.style.pointerEvents = p < 0.05 ? 'none' : 'auto';
    mark.setAttribute('aria-hidden', p < 0.05 ? 'true' : 'false');
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}

// Ease-in-out open/close for <details>/<summary> blocks (FAQs, disclosures).
// Same 0.4s timing as the nav menu drop-down.
function wireDetailsAnimation() {
  document.querySelectorAll('details').forEach(function (details) {
    if (details.dataset.animated) return;
    details.dataset.animated = '1';
    var summary = details.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.classList.contains('is-gliding')) return;
      if (details.open) {
        // Measure the closed height without painting it, glide shut with the
        // content still in place, then close for real
        var from = details.getBoundingClientRect().height;
        details.open = false;
        var to = details.getBoundingClientRect().height;
        details.open = true;
        glideTo(details, from, to, function () { details.open = false; });
      } else {
        glide(details, function () { details.open = true; });
      }
    });
  });
}

// v5: fold buttons (heading folds, Read more, the study reference, Show past
// events). Each .fold-toggle opens and closes the panel named in its
// aria-controls through glide(), as the FAQ accordions do. Closed panels are
// hidden="until-found": still in the page for search engines, and find-in-page
// opens them (beforematch keeps the button in step). A button with
// data-open-label swaps its text while open.
function wireFolds() {
  document.querySelectorAll('.fold-toggle[aria-controls]').forEach(function (btn) {
    if (btn.dataset.wired) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.dataset.wired = '1';
    var closedLabel = btn.hasAttribute('data-open-label') ? btn.textContent : null;

    function mark(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (closedLabel !== null) btn.textContent = open ? btn.getAttribute('data-open-label') : closedLabel;
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.classList.contains('is-gliding')) return;
      if (btn.getAttribute('aria-expanded') === 'true') {
        // Glide shut with the content still in place, then hide it for real
        var from = panel.getBoundingClientRect().height;
        mark(false);
        glideTo(panel, from, 0, function () { panel.setAttribute('hidden', 'until-found'); });
      } else {
        mark(true);
        glide(panel, function () { panel.removeAttribute('hidden'); });
      }
    });

    panel.addEventListener('beforematch', function () { mark(true); });
  });
}

// Auto-advancing carousel (product images on shop item pages).
// Ease-in-out crossfade, defaults to 5s interval, pauses on hover, resets on manual dot click.
function wireCarousels() {
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    if (car.dataset.wired) return;
    car.dataset.wired = '1';
    var slides = car.querySelectorAll('.carousel-slide');
    var dots = car.querySelectorAll('.carousel-dot');
    var interval = parseInt(car.dataset.interval, 10) || 5000;
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;

    function show(i) {
      slides.forEach(function (s, si) { s.classList.toggle('active', si === i); });
      dots.forEach(function (d, di) { d.classList.toggle('active', di === i); });
      index = i;
    }

    function next() { show((index + 1) % slides.length); }
    function prev() { show((index - 1 + slides.length) % slides.length); }

    // Arrow controls, built here so the carousel markup needs no extra buttons
    var frame = car.querySelector('.carousel-slides') || car;
    function arrow(dir, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'carousel-arrow ' + dir;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (dir === 'prev') prev(); else next();
        start();
      });
      frame.appendChild(b);
      return b;
    }
    arrow('prev', 'Previous photo', '‹');
    arrow('next', 'Next photo', '›');

    function start() {
      stop();
      timer = setInterval(next, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { show(di); start(); });
    });

    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    // Keyboard users get the same pause as a hovering mouse
    car.addEventListener('focusin', stop);
    car.addEventListener('focusout', function (e) { if (!car.contains(e.relatedTarget) && !car.matches(':hover')) start(); });

    // Visitors who ask their device to reduce motion get still photos; the arrows and dots still work
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { start = function () {}; return; }
    start();
  });
}


// Left-hand progress rail: shows how far through the page you are, marks each
// section, and jumps to one when clicked. Built here so no page needs markup.
function wireSectionRail() {
  var main = document.querySelector('main');
  if (!main || document.querySelector('.section-rail')) return;

  function hasHeading(el) { return !!el.querySelector('h1, h2, .eyebrow, .eh-sub'); }

  // site-v4 read main's own <section> children. Shopify wraps each section in
  // div.shopify-section, so look one level into those wrappers as well.
  var tops = [];
  Array.prototype.forEach.call(main.children, function (el) {
    if (el.tagName === 'SECTION') tops.push(el);
    else if (el.classList.contains('shopify-section')) {
      Array.prototype.forEach.call(el.children, function (c) { if (c.tagName === 'SECTION') tops.push(c); });
    }
  });
  var sections = tops.filter(hasHeading);

  // Product and event pages nest their sections inside the scrolling column,
  // so fall back to those rather than showing no rail at all.
  if (sections.length < 3) {
    sections = Array.prototype.filter.call(main.querySelectorAll('section'), function (el) {
      return hasHeading(el) && !el.querySelector('section');
    });
  }
  if (sections.length < 3) return;

  function labelFor(el) {
    var h = el.querySelector('h2, h1');
    if (h && h.textContent.trim()) return h.textContent.trim().replace(/\.$/, '');
    var e = el.querySelector('.eyebrow, .eh-sub');
    return e ? e.textContent.trim() : 'Section';
  }

  var rail = document.createElement('nav');
  rail.className = 'section-rail';
  rail.setAttribute('aria-label', 'Page sections');
  rail.innerHTML = '<span class="rail-line"></span><span class="rail-fill"></span>';

  var ticks = sections.map(function (sec, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rail-tick';
    b.setAttribute('aria-label', 'Go to ' + labelFor(sec));
    b.title = labelFor(sec);
    b.addEventListener('click', function () {
      easedScrollTo(sec.getBoundingClientRect().top + window.pageYOffset - navHeight());
    });
    rail.appendChild(b);
    return b;
  });

  var fill = rail.querySelector('.rail-fill');
  document.body.appendChild(rail);

  var ticking = false;

  // Markers sit at even intervals down the rail whatever each section's height,
  // so the rail reads as a set of steps rather than a scale drawing.
  function place() {
    var range = document.documentElement.scrollHeight - window.innerHeight;
    if (range < 240) { rail.classList.add('is-hidden'); return; }
    rail.classList.remove('is-hidden');
    var gaps = Math.max(1, sections.length - 1);
    ticks.forEach(function (t, i) { t.style.top = (i / gaps * 100) + '%'; });
  }

  function topOf(sec) {
    return sec.getBoundingClientRect().top + window.pageYOffset - navHeight();
  }

  var bands = Array.prototype.slice.call(document.querySelectorAll('.fullbleed'));

  // Hidden at the top of the page, and whenever a full-width image sits behind it
  function visibility() {
    var railRect = rail.getBoundingClientRect();
    var overImage = bands.some(function (b) {
      var r = b.getBoundingClientRect();
      return r.bottom > railRect.top && r.top < railRect.bottom;
    });
    rail.classList.toggle('is-muted', window.pageYOffset < 40 || overImage);
  }

  function update() {
    ticking = false;
    visibility();
    var range = document.documentElement.scrollHeight - window.innerHeight;
    if (range <= 0) return;

    var y = window.pageYOffset;
    // Clamp to the scroll range: the last sections often sit closer together
    // than a screen height, so their tops are never reachable otherwise and the
    // rail would stop short of its final marker.
    var tops = sections.map(function (sec) { return Math.min(topOf(sec), range); });
    var current = 0;
    for (var i = 0; i < tops.length; i++) { if (y >= tops[i] - 8) current = i; }

    // Fill interpolates between markers so it meets each one as you arrive.
    var gaps = Math.max(1, sections.length - 1);
    var segStart = tops[current];
    var segEnd = (current < tops.length - 1) ? tops[current + 1] : range;
    var frac = segEnd > segStart ? (y - segStart) / (segEnd - segStart) : 1;
    frac = Math.max(0, Math.min(1, frac));
    var pos = Math.min(1, (current + frac) / gaps);
    fill.style.height = (pos * 100) + '%';

    ticks.forEach(function (t, i) {
      t.classList.toggle('is-active', i === current);
      t.classList.toggle('is-done', i < current);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { place(); onScroll(); });
  window.addEventListener('load', function () { place(); update(); });

  // Backstop: images and fonts finishing late can change the page height after
  // the last scroll event, which would leave the rail showing a stale position.
  var lastY = -1, lastH = -1;
  setInterval(function () {
    var h = document.documentElement.scrollHeight;
    if (window.pageYOffset === lastY && h === lastH) return;
    lastY = window.pageYOffset;
    lastH = h;
    place();
    update();
  }, 400);

  place();
  update();
}

// Buy panel: the price follows the chosen option (event date, pack size)
function wireBuyOptions() {
  document.querySelectorAll('.buy-form').forEach(function (form) {
    if (form.dataset.optionsWired) return;
    form.dataset.optionsWired = '1';
    var price = form.closest('.buy-panel') && form.closest('.buy-panel').querySelector('.bp-price');
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'id' || !e.target.dataset.price || !price) return;
      price.textContent = e.target.dataset.price;
    });
    // Booking questions left blank stay off the order (Shopify keeps a property with an empty value)
    form.addEventListener('submit', function () {
      [].forEach.call(form.querySelectorAll('[name^="properties["]'), function (f) {
        if (f.type !== 'radio' && f.type !== 'checkbox' && !f.value.trim()) f.disabled = true;
      });
    });
  });
}

// Insights, random (homepage): shows a different set of insight cards on each
// visit. The page carries a card for every insight; the newest show until this
// picks, in random order.
function wireRandomInsights() {
  var groups = [];
  [].forEach.call(document.querySelectorAll('[data-random-insight]'), function (card) {
    var g = groups.filter(function (x) { return x.parent === card.parentNode; })[0];
    if (!g) { g = { parent: card.parentNode, cards: [] }; groups.push(g); }
    g.cards.push(card);
  });
  groups.forEach(function (g) {
    var n = Math.min(parseInt(g.cards[0].getAttribute('data-random-insight'), 10) || 3, g.cards.length);
    var pick = g.cards.slice();
    for (var i = pick.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = pick[i]; pick[i] = pick[j]; pick[j] = t;
    }
    pick = pick.slice(0, n);
    g.cards.forEach(function (card) { card.hidden = pick.indexOf(card) === -1; });
    pick.forEach(function (card) { g.parent.appendChild(card); });
  });
}

// --nav-h follows the sticky header's real height, so the homepage hero
// (photo and wordmark) fills the first screen exactly. styles.css has the default.
function wireNavHeight() {
  var header = document.querySelector('.shopify-section-group-header-group') || document.querySelector('header.site-nav');
  if (!header) return;
  function set() { document.documentElement.style.setProperty('--nav-h', header.getBoundingClientRect().height + 'px'); }
  set();
  if (window.ResizeObserver) new ResizeObserver(set).observe(header);
  else window.addEventListener('resize', set);
}

function initSite() {
  wireNavHeight();
  wireRandomInsights();
  wireMenuToggle();
  wireSignup();
  wireDetailsAnimation();
  wireFolds();
  wireCarousels();
  wireBuyOptions();
  wireSmoothScroll();
  wireWordmarkFade();
  wireSectionRail();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSite);
} else {
  initSite();
}

// Theme editor: re-wire a section after Maria edits it
document.addEventListener('shopify:section:load', function () {
  wireRandomInsights();
  wireSignup();
  wireDetailsAnimation();
  wireFolds();
  wireCarousels();
  document.dispatchEvent(new CustomEvent('mg:section-load'));
});

// Theme editor: selecting a block that sits inside a closed fold opens the fold
document.addEventListener('shopify:block:select', function (e) {
  var el = e.target;
  var d = el.closest && el.closest('details');
  if (d && !d.open) d.open = true;
  var body = el.closest && el.closest('.fold-body[hidden]');
  if (body) {
    var btn = document.querySelector('.fold-toggle[aria-controls="' + body.id + '"]');
    if (btn) btn.click(); else body.removeAttribute('hidden');
  }
});
